import './style.scss';

export const Maintenance = () => {
  return (
    <div className="maintenance_root">
      <p>ただいまメンテナンス中です。しばらく時間をおいてアクセスするようお願いいたします。</p>
    </div>
  );
};
